'use strict';

var React = require('react');
var Classnames = require('classnames');

//components
var TextInput = require('../Common/TextInput.jsx');
var CancelDoneButtons = require('../Common/CancelDoneButtons.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
//constants
var Constants = require('../../constants/FundingYourProductConstants.js');
var ProductIds = require('../../constants/ApplicationConstants').ProductIds;

var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');

var OtherFundTypeDetails = React.createClass({
    componentDidMount: function () {
        this.setState({
            paymentMethod: this.props.data.paymentMethod
        });
    },

    componentWillReceiveProps: function (nextProps) {
        this.setState({
            paymentMethod: nextProps.data.paymentMethod
        });
    },

    updateStoreModel: function (event) {
        var fieldId = event.target.model;
        var fieldValue = event.target.value;
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover(fieldId, fieldValue, Constants.RollOverTypes.NON_ROLLOVER, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover(fieldId, fieldValue, this.props.activeFundType, Constants.RollOverTypes.NON_ROLLOVER);
        }       
    },

    cancelOtherFundType: function (e) {
        this.props.onCancelClick(e);
    },

    submitOtherFundType: function (e) {
        this.props.onDoneClick(e);
    },

    render: function () {
        //local variables
        var inlineMsg = '';

        //Inline message
        if (this.props.data.paymentMethod && this.props.data.paymentMethod !== Constants.ContributionValues.DIRECT_D) {
            if (this.props.product === ProductIds.SUPER || this.props.product === ProductIds.PENSION) {
                if (this.props.activeFundType === Constants.FundingTypes.Personal_injury_payment) {
                    inlineMsg = this.props.content.fundingYourProduct.paymentOptionPersonalInjury;
                } else if (this.props.activeFundType === Constants.FundingTypes.CGT_contribution) {
                    inlineMsg = this.props.content.fundingYourProduct.paymentOptionCGT;
                } else if (this.props.activeFundType === Constants.FundingTypes.Downsizer_contribution) {
                    inlineMsg = this.props.content.fundingYourProduct.paymentOptionDownsizer;
                } else {
                    inlineMsg = this.props.content.fundingYourProduct.paymentOption;
                }
            } else if(this.props.product === ProductIds.INVESTMENT) {
                inlineMsg = this.props.content.fundingYourProduct.paymentOption;
            }
        }
        var hideOtherFundTypeDetails = true;
        if (this.props.data.paymentMethod !== '' && this.props.data.paymentMethod !== Constants.ContributionValues.DIRECT_D && this.props.data.paymentMethod !== Constants.ContributionValues.INTERNAL_TRANSFER) {
            hideOtherFundTypeDetails = false;
        }
        var isNumberOfRolloversValid = _.filter(this.props.data.errorList, { id: 'fypMaxRolloversError' });
        var maxRolloverError = null;
        if (isNumberOfRolloversValid.length > 0 && isNumberOfRolloversValid[0]) {
            maxRolloverError =
                <InlineMessage id="fypMaxFundingSourcesError"
                               isHidden={!isNumberOfRolloversValid[0].message}
                               type={isNumberOfRolloversValid[0].type}
                               message={isNumberOfRolloversValid[0].message} />;
        }
        return (
            <div className={Classnames({ hidden: hideOtherFundTypeDetails })} >
                <TextInput id="fypOtherFundTypesAmount"
                           model="rollOverAmount"
                           className={Classnames('text-input-amount',{ 'other-fund-types-edit-mode': this.props.inSummary })}
                           label="Amount"
                           symbol="currency"
                           contextualMessage={inlineMsg}
                           value={this.props.data.rollOverAmount}
                           onBlur={this.updateStoreModel}
                           errorList={this.props.data.errorList} />
                <CancelDoneButtons id="nonRolloverFormButton"
                                   index={this.props.index}
                                   onClickCancel={this.cancelOtherFundType}
                                   onClickDone={this.submitOtherFundType} />
                {maxRolloverError}
            </div>
		);
    }
});

module.exports = OtherFundTypeDetails;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/OtherFundTypeDetails.jsx